export const convertUser = (user: any) => ({
    firstname: user.firstname,
    lastname: user.lastname,
    contactid: user.contactid,
    phone: user.eft_telephonemobile2,
    dateDeModification: (user.eft_date_de_modification || user.eft_datedemodification) ?? null,
	espaceClientDesactive: user.espaceClientDesactive
})
